import { useEffect } from  "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import Grid from "@mui/joy/Grid";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import List from "@mui/joy/List";
import Chip from "@mui/joy/Chip";
import Card from "@mui/joy/Card";
import Tooltip from "@mui/joy/Tooltip";

import useDedicatedAssignment from "hooks/useDedicatedAssignment";
import useUserIdentity from "hooks/useUserIdentity";
import useAuth from "hooks/useAuth";
// import WelcomeMessage from "./WelcomeMessage";
// import ProjectList from "./ProjectList";
import { MutualsListComponent } from "./MutualsList";

import RequestsPane from "components/RequestsPane";

import Listicle from "components/Listicle";
// import LockedFeature from "./LockedFeature";
// import { Divider } from "@mui/joy";

const HomeClientTasks = observer(() => {
    return (
        <Stack spacing={1}>
        <RequestsPane />
        {/*
            <Divider />
            <LockedFeature
                lockedIconName="DayOnesProject"
                outlined={false}
                copy="Projects">
                <Listicle />
                </LockedFeature>
          */}
        </Stack>
    );
});

const HomeClientProjects = observer(() => {
    return (
        <Stack>
            <Listicle />
        </Stack>
    );
});


const DedicatedAssistantList = observer(() => {
    const { currentIdentity } = useUserIdentity();
    const { getDedicatedAssignmentsByIdentity } = useDedicatedAssignment();
    const dedicatedAssignments = getDedicatedAssignmentsByIdentity(currentIdentity.key);

    return (
        <Stack m={1}>
            <Typography
                fontSize={{ xs: 'md', md: 'lg' }}
                fontWeight="lg"
                sx={{ mr: 'auto' }}
            >
                Your Dedicated Team
            </Typography>
            <List>
                {dedicatedAssignments.map(assignment =>
                        <MutualsListComponent key={assignment.key} identityKey={assignment.assistant_identity} />
                )}
            </List>

        </Stack>
    );
});

export const FaqCard = () => {
    return (
        <Card >
            <Stack
                display={{ xs: "none", sm: "flex" }}
                spacing={1}
            >
                <Typography level="title-lg">
                    Welcome!
                </Typography>

                <Typography level="body-md">
                    This is the best place to get things done. We're so glad you made it.
                </Typography>


                <Typography level="title-md">
                    This app is in <Tooltip
                        arrow
                        title="but things should be much better than before 🤞">
                        <Chip color="success" variant="outlined" >beta</Chip></Tooltip>
                </Typography>

                <Typography level="body-md">
                    Send any feedback, commments, and bug reports directly to our founder via the <Link to={"/support"}>support link</Link>.
                </Typography>

                <Typography level="title-md">
                    What happened to the old site?
                </Typography>
                <Typography level="body-md">
                    The old site is still up! You can still visit it.
                </Typography>

                <Typography level="title-md">
                    Why is this called Day Ones?
                </Typography>

                <Typography>
                                To remind ourselves (and you) who this site is built for.
                             </Typography>
                             <Typography>
                                             Day Ones is the "code name" for the revamped site. Eventually this site will replace the old one and the code name will go away. You'll be able to say you were here on Day One.</Typography>
            </Stack>
        </Card>

    );
};

// const DedicatedAssistantExplainer = observer(() => {
//     return (
//         <Stack>
//             <Typography
//                 level="body-xs">
//                 No Dedicated Assistants
//             </Typography>
//         </Stack>
//     );
// });


const HomeClient = observer(() => {
    const { currentIdentity } = useUserIdentity();
    const { currentUser } = useAuth();
    const { hasDedicatedAssistant } = useDedicatedAssignment();
    const { fetchDedicatedAssignmentsByIdentity } = useDedicatedAssignment();


    if(currentIdentity.role != 'client')
        return null;

    useEffect(() => {
        fetchDedicatedAssignmentsByIdentity(currentIdentity.uuid, currentIdentity.uuid);
    }, [fetchDedicatedAssignmentsByIdentity, currentIdentity.uuid]);

    return (
        <Stack>
            <Grid container>

            <Grid xs={12} sm={7} md={7}>

            {/* show the requests on the homepage if they have a tasks subscription */}
            { (currentUser.subscription_product == "tasks" || !currentUser.subscription_product) ?
                <HomeClientTasks />
                :
                <HomeClientProjects />
            }

                </Grid>

                <Grid xs={12} sm={5} md={5}>
                    <Stack
                        sx={{ display: { xs: "none", sm: "flex" } }}
                        p={2}
                        pb={1.5}
                        spacing={2}>

                        {(currentUser.subscription_product == "dedicated" &&
                            !hasDedicatedAssistant(currentIdentity.key)) &&
                            <Card color="primary">
                                <Typography level="title-md">
                                    About Your Dedicated Assistant
                                </Typography>
                                <Typography level="body-md">
                                    You're signed up for a dedicated assistant, but we still need to assign one to you. We'll reach out via email to get that set up. In the meantime, feel free to click around and get comfortable.
                                </Typography>
                            </Card>
                        }

                        {/* We don't need to check to see if they have
                        the right subscription product. If they have a
                        dedicated assistant, they have it. */}

                        { hasDedicatedAssistant(currentIdentity.key) &&
                            <DedicatedAssistantList />}

                        <FaqCard />


                        {/*
                    { !hasDedicatedAssistant(currentIdentity.key) &&
                        <DedicatedAssistantExplainer /> }
                    */}

                    </Stack>
                </Grid>

            </Grid>
        </Stack>
    );
});

export default HomeClient;
